export const APPROVAL_TYPE = {
  PARTICIPANT: 'participant',
  NO_TESTERS_FOUND: 'no_testers_found',
  UNMODERATED_VIDEO: 'unmoderated_video',
  MODERATED_VIDEO_LINK: 'moderated_video_link',
  ANALYTICS: 'analytics',
  DID_NOT_SHOW: 'did_not_show',
  CARD_SORT_PARTICIPANT: 'card_sort_participant',
  CARD_SORT_SURVEY: 'card_sort_survey',
  TREE_TEST_PARTICIPANT: 'tree_test_participant',
  TREE_TEST_SURVEY: 'tree_test_survey',
  SURVEY_PARTICIPANT: 'survey_participant',
  SURVEY_RESPONSE: 'survey_response',
};
